import { render, staticRenderFns } from "./CardStatistic.vue?vue&type=template&id=7d4bd359&scoped=true"
import script from "./CardStatistic.vue?vue&type=script&lang=ts"
export * from "./CardStatistic.vue?vue&type=script&lang=ts"
import style0 from "./CardStatistic.vue?vue&type=style&index=0&id=7d4bd359&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4bd359",
  null
  
)

export default component.exports